import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEligibility } from "@/contexts/EligibilityContext";
import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";

const AssessmentRecommendations = () => {
  const { getLatestAssessment } = useEligibility();
  const [assessment, setAssessment] = useState<any>(null);

  useEffect(() => {
    const fetchAssessment = async () => {
      const data = await getLatestAssessment();
      setAssessment(data);
    };
    fetchAssessment();
  }, [getLatestAssessment]);

  if (!assessment?.results?.recommendations) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recommendations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {assessment.results.recommendations.map((recommendation: string, index: number) => (
            <div key={index} className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-primary mt-0.5" />
              <p className="text-sm">{recommendation}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AssessmentRecommendations;